export default __webpack_public_path__ + "static/media/fig25.b91fd43d.png";